import React from "react";
import { useLocation } from "react-router-dom";

const SynkChainScan: React.FC = () => {
  const location = useLocation();
  const baseUrl = window.location.origin;
  const iframeUrl = `${baseUrl}/synk-chainscan`;

  return (
    <div className="relative w-full h-full">
      <iframe
        src={iframeUrl}
        title="SynkChainScan"
        className="w-full h-full border-none"
        sandbox="allow-scripts allow-same-origin allow-popups allow-downloads"
        allow="camera; microphone; fullscreen"
      ></iframe>
    </div>
  );
};

export default SynkChainScan;
